import React from "react";
import { ShoppingBag, Dog, Wrench, Scissors } from "lucide-react";

interface ModeSwitcherProps {
    activeMode: string;
    onModeChange: (mode: any) => void;
    innerclassName?: string
    classname?: string
}

const ModeSwitcher: React.FC<ModeSwitcherProps> = ({ activeMode, onModeChange,innerclassName='',classname ='' }) => {
    const modes = [
        { id: "Products", label: "Products", icon: <ShoppingBag size={14} />, activeClass: "bg-iconColor text-white" },
        { id: "Pets", label: "Pets", icon: <Dog size={14} />, activeClass: "bg-iconColor text-white" },
        { id: "Services", label: "Services", icon: <Scissors size={14} />, activeClass: "bg-iconColor text-white" },
    ];

    return (
        <div className={`flex items-center gap-2 bg-logoHeading p-1 rounded-full ${classname}`}>
            {modes.map((m) => (
                <button
                    key={m.id}
                    onClick={() => onModeChange(m.id)}
                    className={`flex items-center gap-2 md:px-3 px-2 py-2 rounded-full transition-all duration-300 transform font-semibold md:text-sm text-xs
                        ${activeMode === m.id
                            ? `${m.activeClass} scale-105`
                            : "text-white/80 hover:bg-white/10 hover:text-white"
                        } ${innerclassName}`}
                >
                    {m.icon}
                    <span>{m.label}</span>
                </button>
            ))}
        </div>
    );
};

export default ModeSwitcher;